export default __webpack_public_path__ + "assets/models/4f08c5b82ceb64b1524449836d076cb9.glb";